module.exports = new __parcel__URL__("okx.11891fb5.svg").toString();